import { render, staticRenderFns } from "./SendWithdrawal.vue?vue&type=template&id=268d857e&scoped=true"
import script from "./SendWithdrawal.vue?vue&type=script&lang=js"
export * from "./SendWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d857e",
  null
  
)

export default component.exports